/* eslint-disable react/no-unknown-property */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';

import Image from 'Component/Image';
import {
    THUMBNAIL_KEY
} from 'Component/ProductGallery/ProductGallery.config';
import {
    ProductGalleryThumbnailImage as SourceProductGalleryThumbnailImage
} from 'SourceComponent/ProductGalleryThumbnailImage/ProductGalleryThumbnailImage.component';
import { formatImageSetUrl, formatImageUrl } from 'Util/ImageCDN';

import './ProductGalleryThumbnailImage.style';

/** @namespace Scandipwa/Component/ProductGalleryThumbnailImage/Component */
export class ProductGalleryThumbnailImageComponent extends SourceProductGalleryThumbnailImage {
    static propTypes = {
        media: PropTypes.shape({
            label: PropTypes.string,
            file: PropTypes.string,
            media_type: PropTypes.string,
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            thumbnail: PropTypes.shape({
                url: PropTypes.string
            })
        }).isRequired,
        index: PropTypes.number.isRequired,
        onActiveImageChange: PropTypes.func.isRequired,
        isActiveImage: PropTypes.bool,
        isLoading: PropTypes.bool.isRequired
    };

    renderImage() {
        const {
            media: {
                label: alt,
                thumbnail: { url: thumbnailUrl } = {},
                id
            },
            cloudinaryStatus
        } = this.props;

        if (id === THUMBNAIL_KEY) {
            return this.renderPlaceholder();
        }

        const src = thumbnailUrl || '';

        return (
            <Image
              srcset={ formatImageSetUrl(cloudinaryStatus, src, ['157', '220', '353', '480', '706']) }
              sizes={ `(max-width: 375px) 157px,
                       (max-width: 767px) 353px,
                        480px` }
              src={ formatImageUrl(cloudinaryStatus, src, '480') }
              alt={ alt }
              ratio="custom"
              mix={ { block: 'ProductGalleryThumbnailImage' } }
            />
        );
    }

    onActiveImageChange = () => {
        const { index, onActiveImageChange } = this.props;
        onActiveImageChange(index);
    };

    render() {
        const { isActiveImage, isLoading } = this.props;

        return (
            <button
              block="ProductGalleryThumbnailImage"
              onClick={ this.onActiveImageChange }
              mods={ { isActiveImage, isLoading } }
            >
                { this.renderMedia() }
            </button>
        );
    }
}

export default ProductGalleryThumbnailImageComponent;
